import { transport } from "@/src/config/apiConfig.js";
import { paginationDefaults } from "@/src/constants/analyticConstants.js";
import { createTransport } from "@/src/config/transportFactory.js";

const { transport: communicationTransport } = createTransport("communication");

export default {
  // ------------------------------ Analytics V2 ------------------------------
  V2: {
    // ------------------------------ CONTACTS ------------------------------
    async fetchContactCount(params) {
      try {
        let res = await transport.get(`/api/analytics_service/contact/count`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching contact count: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ COMPANIES------------------------------

    async fetchCompanyCount(params) {
      try {
        let res = await transport.get(`/api/analytics_service/company/count`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching company count: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ LEADS ------------------------------

    async fetchLeadCount(params) {
      try {
        let res = await transport.get(`/api/analytics_service/lead/count`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching lead count: ", error);
        throw error;
      }
    },

    // ------------------------------ DEALS ------------------------------

    async fetchTotalPipelineValue(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/deal/total_pipeline_value`,
          { params: params },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching total pipeline value: ",
          error,
        );
        throw error;
      }
    },

    async fetchDealCount(params) {
      try {
        let res = await transport.get(`/api/analytics_service/deal/count`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching deal count: ", error);
        throw error;
      }
    },

    async fetchAverageDealAge(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/deal/average_deal_age`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching average deal age: ",
          error,
        );
        throw error;
      }
    },

    async fetchDealWinLostRatio(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/deal/win_lost_ratio`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching deal win lost ratio: ",
          error,
        );
        throw error;
      }
    },

    async fetchDealRevenueMonthly(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/deal/revenue/monthly`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching deal revenue monthly: ",
          error,
        );
        throw error;
      }
    },

    async fetchDealPipelineFunnel(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/deal/pipeline_funnel`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching deal pipeline funnel: ",
          error,
        );
        throw error;
      }
    },

    async fetchDealConversionValue(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/deal/conversion`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching deal conversion value: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ EMAIL CAMPAIGNS ------------------------------

    async fetchEmailSentCount(params) {
      try {
        let res = await transport.get(`/api/analytics_service/email/count`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching email sent count: ",
          error,
        );
        throw error;
      }
    },

    async fetchEmailCampaignCount(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/email_campaign/count`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching email campaign count: ",
          error,
        );
        throw error;
      }
    },

    async fetchEmailCampaignPerformance(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/email_campaign/performance`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching email campaign performance: ",
          error,
        );
        throw error;
      }
    },

    async fetchEmailCampaignFunnel(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/email_campaign/funnel`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching email campaign funnel: ",
          error,
        );
        throw error;
      }
    },

    async fetchEmailCampaignEngagement(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/email_campaign/engagement`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching email campaign engagement: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceRateMetrics(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/rate_metrics`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence rate metrics: ",
          error,
        );
      }
    },

    // ------------------------------ CALL CAMPAIGNS ------------------------------

    async fetchCallCount(params) {
      try {
        let res = await transport.get(`/api/analytics_service/call/count`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching call count: ", error);
        throw error;
      }
    },

    async fetchCallAverageDuration(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/call/average_duration`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching call average duration: ",
          error,
        );
        throw error;
      }
    },

    async fetchCallEngagement(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/call/engagement`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching call engagement: ",
          error,
        );
        throw error;
      }
    },

    async fetchCallEngagementByUser(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/call/engagement/user`,
          { params: params },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching call engagement by user: ",
          error,
        );
        throw error;
      }
    },

    async fetchCallDispositionAnalytics(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/call/disposition_analytics`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching call disposition analytics: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ LINKEDIN CAMPAIGNS ------------------------------

    async fetchLinkedinCount(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/linkedin_campaign/count`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching linkedin count: ",
          error,
        );
        throw error;
      }
    },

    async fetchLinkedinCampaign(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/linkedin_campaign/activity`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching linkedin campaign: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ SALES ACTIVITIES ------------------------------

    async fetchSalesActivityByUser(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sales_activity/user`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sales activity by user: ",
          error,
        );
        throw error;
      }
    },

    async exportSalesActivityByUser(params) {
      try {
        return await transport.get(
          `/api/analytics_service/sales_activity/export/user/csv`,
          {
            params: params,
            responseType: "blob",
          },
        );
      } catch (error) {
        console.error(
          "An error occurred while exporting sales activity by user: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ MEETING ------------------------------

    async fetchMeetingCount(params) {
      try {
        let res = await transport.get(`/api/analytics_service/meeting/count`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching meeting count: ",
          error,
        );
        throw error;
      }
    },

    async fetchMeetingTrends(params) {
      try {
        let res = await transport.get(`/api/analytics_service/meeting/trends`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching meeting trends: ",
          error,
        );
        throw error;
      }
    },

    async fetchMeetingAgents(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/meeting/meeting_agents`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching meeting agents: ",
          error,
        );
        throw error;
      }
    },

    async fetchMeetingWeekDayAnalytics(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/meeting/week_day_analytics`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching meeting week day analytics: ",
          error,
        );
        throw error;
      }
    },

    async fetchMeetingDayHourAnalytics(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/meeting/day_hour_analytics`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching meeting day hour analytics: ",
          error,
        );
        throw error;
      }
    },

    async fetchBookedMembers(params) {
      try {
        let res = await transport.get(`/api/analytics_service/meeting/user`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching booked members: ",
          error,
        );
        throw error;
      }
    },

    async fetchMeetingUserOverview(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/meeting/user/overview`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching meeting user overview: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ ROUTING FORMS ------------------------------

    async fetchRoutingFormCount(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/meeting/routing_form/count`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching routing form count: ",
          error,
        );
        throw error;
      }
    },

    async fetchRoutingFormFunnel(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/meeting/routing_form/funnel`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching routing form funnel: ",
          error,
        );
        throw error;
      }
    },

    async fetchRoutingFormOutcome(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/meeting/routing_form/outcome`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching routing form outcome: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ SEQUENCES ------------------------------

    async fetchSequencePeopleCount(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/entity/count`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence people count: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceEmailCount(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/email/count`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence email count: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceEmailEngagement(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/email/engagementData`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence email engagement: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceEmailFunnel(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/email/funnel`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence email funnel: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceLinkedinCount(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/linkedin/count`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence linkedin count: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceLinkedinEngagement(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/linkedin/engagementData`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence linkedin engagement: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceTasksCount(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/task/count`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence linkedin count: ",
          error,
        );
        throw error;
      }
    },

    async fetchSequenceTaskEngagement(params) {
      try {
        let res = await transport.get(
          `/api/analytics_service/sequence/task/engagementData`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching sequence task engagement: ",
          error,
        );
        throw error;
      }
    },

    async fetchWorkspaceMarketingCampaignStats(params) {
      try {
        let res = await communicationTransport.get(
          `/communications/analytics/workspaces/stats`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching workspace email stats: ",
          error,
        );
        throw error;
      }
    },

    async fetchWorkspaceMarketingCampaignLine(params) {
      try {
        let res = await communicationTransport.get(
          `/communications/analytics/workspaces/line`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching workspace email line: ",
          error,
        );
        throw error;
      }
    },

    async fetchWorkspaceMarketingCampaignFunnel(params) {
      try {
        let res = await communicationTransport.get(
          `/communications/analytics/workspaces/funnel`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching workspace email funnel: ",
          error,
        );
        throw error;
      }
    },

    async fetchMarketingCampaignSentByDateRange(params) {
      try {
        let res = await transport.get(
          `/api/marketing/campaigns/sent_by_date_range`,
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching marketing campaign sent by date range: ",
          error,
        );
        throw error;
      }
    },

    async fetchMarketingEmailCount(params) {
      try {
        let res = await transport.get(`/api/marketing/campaigns/total_sent`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching marketing email count: ",
          error,
        );
        throw error;
      }
    },

    async exportMarketingCampaignsAnalytics(payload) {
      try {
        const res = await transport.post(
          "/api/marketing/campaigns/export_analytics",
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while exporting marketing campaigns analytics: ",
          error,
        );
        throw error;
      }
    },

    async exportSequenceAnalytics(payload) {
      try {
        const res = await transport.post(
          "/api/analytics/export_sequence_analytics",
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while exporting sequence analytics: ",
          error,
        );
        throw error;
      }
    },
  },

  // ------------------------------ Analytics V3 ------------------------------

  V3: {
    // ------------------------------ Dashboard APIs ------------------------------
    async fetchDashboards(params) {
      try {
        let res = await transport.get("/api/analytics/dashboards", {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching dashboards: ", error);
        throw error;
      }
    },

    async fetchDashboardByID(id) {
      try {
        const res = await transport.get(`/api/analytics/dashboards/${id}`);
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching dashboard by ID: ",
          error,
        );
        throw error;
      }
    },

    async createDashboard(payload) {
      try {
        const res = await transport.post("/api/analytics/dashboards", payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while creating dashboard: ", error);
        throw error;
      }
    },

    async updateDashboard(id, payload) {
      try {
        const res = await transport.put(
          `/api/analytics/dashboards/${id}`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error("An error occurred while updating dashboard: ", error);
        throw error;
      }
    },

    async deleteDashboard(id) {
      try {
        const res = await transport.delete(`/api/analytics/dashboards/${id}`);
        return res.data;
      } catch (error) {
        console.error("An error occurred while deleting dashboard: ", error);
        throw error;
      }
    },

    async changeDashboardStatus(id, payload) {
      try {
        const res = await transport.post(
          `/api/analytics/dashboards/${id}/status`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while changing dashboard status: ",
          error,
        );
        throw error;
      }
    },

    async saveAsNewDashboard(id, payload) {
      try {
        const res = await transport.post(
          `/api/analytics/dashboards/${id}/save-as-new`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while saving as new dashboard: ",
          error,
        );
        throw error;
      }
    },

    async discardChanges(id) {
      try {
        const res = await transport.post(
          `/api/analytics/dashboards/${id}/discard-changes`,
        );
        return res.data;
      } catch (error) {
        console.error("An error occurred while discarding changes: ", error);
        throw error;
      }
    },

    async executeDashboardQuery(id, payload = {}, params = {}) {
      try {
        const res = await transport.post(
          `/api/analytics/dashboards/${id}/execute`,
          payload,
          { params },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while executing dashboard query: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ Conversation Messages API ------------------------------
    async fetchConversationMessages(params) {
      try {
        const res = await transport.get(
          "/api/analytics/conversation-messages",
          {
            params: params,
          },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching conversation messages: ",
          error,
        );
        throw error;
      }
    },

    async fetchConversationMessageByID(id) {
      try {
        const res = await transport.get(
          `/api/analytics/conversation-messages/${id}`,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching conversation message by ID: ",
          error,
        );
        throw error;
      }
    },

    async createConversationMessage(payload) {
      try {
        const res = await transport.post(
          "/api/analytics/conversation-messages",
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while creating conversation message: ",
          error,
        );
        throw error;
      }
    },

    async updateConversationMessage(id, payload) {
      try {
        const res = await transport.put(
          `/api/analytics/conversation-messages/${id}`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while updating conversation message: ",
          error,
        );
        throw error;
      }
    },

    async deleteConversationMessage(id) {
      try {
        const res = await transport.delete(
          `/api/analytics/conversation-messages/${id}`,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while deleting conversation message: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ Charts APIs ------------------------------
    async fetchCharts(params) {
      try {
        const res = await transport.get("/api/analytics/charts", {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching charts: ", error);
        throw error;
      }
    },

    async fetchChartByID(id, params = {}) {
      try {
        const res = await transport.get(`/api/analytics/charts/${id}`, {
          params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching chart by ID: ", error);
        throw error;
      }
    },

    async createChart(payload) {
      try {
        const res = await transport.post("/api/analytics/charts", payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while creating chart: ", error);
        throw error;
      }
    },

    async updateChart(id, payload) {
      try {
        const res = await transport.put(`/api/analytics/charts/${id}`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while updating chart: ", error);
        throw error;
      }
    },

    async deleteChart(id) {
      try {
        const res = await transport.delete(`/api/analytics/charts/${id}`);
        return res.data;
      } catch (error) {
        console.error("An error occurred while deleting chart: ", error);
        throw error;
      }
    },

    async createAICard(payload) {
      try {
        const res = await transport.post("/api/analytics/ai-cards", payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while creating AI card: ", error);
        throw error;
      }
    },

    async fetchAICards(params) {
      try {
        const res = await transport.get("/api/analytics/ai-cards", {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching AI cards: ", error);
        throw error;
      }
    },

    async fetchAICardByID(id) {
      try {
        const res = await transport.get(`/api/analytics/ai-cards/${id}`);
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching AI card by ID: ",
          error,
        );
        throw error;
      }
    },

    async updateAICardNamePrompt(id, payload) {
      try {
        const res = await transport.put(
          `/api/analytics/ai-cards/${id}/name-prompt`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while updating AI card name/prompt: ",
          error,
        );
        throw error;
      }
    },

    async updateAICardResponse(id, payload) {
      try {
        const res = await transport.put(
          `/api/analytics/ai-cards/${id}/response`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while updating AI card response: ",
          error,
        );
        throw error;
      }
    },

    async deleteAICard(id) {
      try {
        const res = await transport.delete(`/api/analytics/ai-cards/${id}`);
        return res.data;
      } catch (error) {
        console.error("An error occurred while deleting AI card: ", error);
        throw error;
      }
    },

    // ------------------------------ Dashboard Configuration APIs ------------------------------
    async getDashboardConfigurationByID(id, params) {
      try {
        const res = await transport.get(
          `/api/analytics/dashboard-configurations/${id}`,
          { params: params },
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching dashboard configuration configuration: ",
          error,
        );
        throw error;
      }
    },

    async createDashboardConfigurations(id, payload) {
      try {
        const res = await transport.post(
          `/api/analytics/dashboard-configurations/${id}`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while creating dashboard configuration: ",
          error,
        );
        throw error;
      }
    },

    async updateDashboardConfigurations(id, payload) {
      try {
        const res = await transport.put(
          `/api/analytics/dashboard-configurations/${id}`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while updating dashboard configuration: ",
          error,
        );
        throw error;
      }
    },

    async deleteDashboardConfiguration(id) {
      try {
        const res = await transport.delete(
          `/api/analytics/dashboard-configurations/${id}`,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while deleting dashboard configuration: ",
          error,
        );
        throw error;
      }
    },

    async migrateFilters() {
      try {
        const res = await transport.post(
          `/api/analytics/dashboard-configurations/migrate-filters`,
        );
        return res.data;
      } catch (error) {
        console.error("An error occurred while migrating filters: ", error);
        throw error;
      }
    },

    // ------------------------------ Visualization APIs ------------------------------
    async fetchVisualizationByID(
      id,
      params = {},
      page = 1,
      pageSize = paginationDefaults.pageSize,
    ) {
      try {
        const res = await transport.get(`/api/analytics/visualization/${id}`, {
          params: {
            ...params,
            page,
            page_size: pageSize,
          },
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching visualization by ID: ",
          error,
        );
        throw error;
      }
    },

    async exportVisualizationByID(id, payload) {
      try {
        const res = await transport.post(
          `/api/analytics/visualization/${id}/export`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while exporting visualization by ID: ",
          error,
        );
        throw error;
      }
    },

    // ------------------------------ Templates APIs ------------------------------
    async fetchTemplates(params) {
      try {
        const res = await transport.get("/api/analytics/templates", {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching templates: ", error);
        throw error;
      }
    },

    async fetchTemplateByID(id) {
      try {
        const res = await transport.get(`/api/analytics/templates/${id}`);
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching template by ID: ",
          error,
        );
        throw error;
      }
    },

    async applyTemplate(id, payload) {
      try {
        const res = await transport.post(
          `/api/analytics/templates/${id}/apply`,
          payload,
        );
        return res.data;
      } catch (error) {
        console.error("An error occurred while applying template: ", error);
        throw error;
      }
    },

    async fetchTemplateCategories(params) {
      try {
        const res = await transport.get(`/api/analytics/templates/categories`, {
          params: params,
        });
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching template categories: ",
          error,
        );
        throw error;
      }
    },

    async fetchListOfCategoryApps() {
      try {
        const res = await transport.get(
          `/api/analytics/templates/installed-apps`,
        );
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching list of category apps: ",
          error,
        );
        throw error;
      }
    },
  },
};
